import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Section as BaseSection } from "../components/Section";
import greenNoise from "../assets/images/green_noise.jpg";
import { ContactUs } from "../components/ContactUs";
import { Word } from "../components/word";
import { WordShift } from "../components/WordShift";
import { TABLET } from "../constant/Breakpoints";

const Section = styled(BaseSection)`
  background: url("${greenNoise}");
  margin-top: -96px;

  @media screen and (max-width: ${TABLET}px) {
    margin-top: 0px;
    
    > div {
      padding-top: 0;
    }
  }
`;

const BigP = styled.p`
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  max-width: 700px;
  margin: 12px;
  color: white;
  margin-bottom: 40px;
`;

export const LeCollectif = () => {
  const [center, setCenter] = useState(false);

  useEffect(() => {
    setCenter(window.innerWidth < TABLET);
  }, []);

  return (
    <Section>
      <BigP>
        Nous sommes un collectif de{" "}
        <WordShift
          words={[
            <Word word="communicants" color="white" />,
            <Word word="designers" color="white" />,
            <Word word="developpeurs" color="white" />,
          ]}
          center={center}
        />
      </BigP>
      <BigP>
        Nous accompagnons les projets engagés pour un monde plus durable et plus
        juste.
      </BigP>
      <ContactUs />
    </Section>
  );
};
